import { render, staticRenderFns } from "./BannerForm.vue?vue&type=template&id=e44503c8"
import script from "./BannerForm.vue?vue&type=script&lang=ts"
export * from "./BannerForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports